import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { logout } from '../../../redux';
import { connect } from 'react-redux';
import './index.css';

function Navbar (props) {
    const {
        isAuthenticated,
        logout,
    } = props;

    const [clicked, setClicked] = useState(false);

    const handleClick = () => {
        setClicked(!clicked);
    }

    const show = clicked ? {display: "block"} : {display: "none"};
    const hover = clicked ? {backgroundColor: "#ef6a6e"} : {};

    return (
        <nav>
            <div className="dropdown">
                <Link to="/">
                    <div className="logo">
                        <img src={require("../../../Images/logo.png")} alt="NTR Negotiation and Review Feedback"/>
                    </div>
                </Link>
                <div className="dropbtn" onClick={handleClick} style={hover}>
                    <i className="fa fa-bars"></i>
                    <div className="dropdown-content" style={show}>
                        <Link to="/about"><li>About</li></Link>
                        <Link to="/contact"><li>Contact</li></Link>
                        <Link to="/faq"><li>FAQ</li></Link>
                        {isAuthenticated ? null : <Link to="/login"><li>Login</li></Link>}
                        {isAuthenticated ? <Link to="/profile"><li>Profile</li></Link> : null}
                        {isAuthenticated ? <div onClick={logout}><li>Logout</li></div> : null}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default connect(state => state.root, { logout })(Navbar);
